import React, { useContext } from 'react';
import SessionContext from '@providers/Session/SessionContext';

const RoleChecker = ({ role, children, client = 'portal' }) => {
  const { effectiveRoles } = useContext(SessionContext);
  const hasRole = roleToCheck =>
    effectiveRoles?.[client]?.includes(roleToCheck);
  return <>{hasRole(role) ? children : null}</>;
};

export const useCheckRole = ({ role, client = 'portal' }) => {
  const { effectiveRoles } = useContext(SessionContext);
  return effectiveRoles?.[client]?.includes(role);
};

export const useFilterRoutes = ({ routes, client = 'portal' }) => {
  const { effectiveRoles } = useContext(SessionContext);
  const childrenHasRole = children =>
    children.some(({ role }) => effectiveRoles?.[client]?.includes(role));
  return routes
    .filter(({ children }) => childrenHasRole(children))
    .map(route => {
      // eslint-disable-next-line no-param-reassign
      route.children = route.children.filter(child =>
        effectiveRoles?.[client]?.includes(child.role),
      );
      return route;
    });
};

export default RoleChecker;
